import { Theme } from "@emotion/react";
import { Container, SxProps } from "@mui/material";
import React, { ElementType, ReactNode } from "react";

interface ContainerProps {
    component: ElementType;
    sx?: SxProps<Theme>;
    children?: ReactNode
}

const ContainerComponent = (props: ContainerProps) => {
    return <Container
        sx={props.sx}
        component={props.component as React.ElementType}
    >
        {props.children}
    </Container>
}

export default ContainerComponent;